import * as React from 'react';
import { CardFolderTabProps } from './Tab';

export interface CardFolderTabsProps {
  children?: React.ReactNode;
  dataHook?: string;
  activeId: string;
  onTabChange?: (newActiveId: string) => void;
  maxTabWidth?: React.CSSProperties['maxWidth'];
  fluid?: boolean;
  ellipsis?: boolean;
  size?: TabFontSize;
}

export type TabFontSize = 'medium' | 'small';
export default class CardFolderTabs extends React.PureComponent<CardFolderTabsProps> {
  static Tab: (props?: CardFolderTabProps) => React.ReactElement;
}
